import {LoginCredential, LoginResponse} from "./models";
import httpClient, {ApiResponseWrapper} from "../../http-client";
import {BaseServiceClass} from "../../base-service-class";

export default class UserApi extends BaseServiceClass {
    static login(userLogin: LoginCredential) {
        const path = "/api/Auth/Login"
        return httpClient.post<ApiResponseWrapper<LoginResponse>>(`${this.BASE_URL}${path}`, userLogin).then((res) => res.data);
    }
}